"use client"
import React, { useCallback, useMemo } from "react"
import { useTranslations } from "next-intl"
import { useQueryState } from "nuqs"
import { planItemParser } from "../queryStates"
import { Card, Stack, Text, Button, Title, Space, ThemeIcon, Center } from "@mantine/core"
import { IconUser } from "@tabler/icons-react"
import classes from "./styles/PlanItem.module.css"

export function SoloCard() {
  const [selectedPlan, selectPlan] = useQueryState("plan", planItemParser)
  const t = useTranslations()

  const isSelected = useMemo(() => {
    return selectedPlan === "solo"
  }, [selectedPlan])

  const handleClick = useCallback(() => {
    selectPlan("solo")
  }, [selectPlan])

  const formatTextWithBold = (text: string) => {
    const parts = text.split(/(\*\*[^*]+\*\*)/)
    return parts.map((part, index) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        const boldText = part.slice(2, -2)
        return (
          <Text key={index} component="span" fw={700} c="dark">
            {boldText}
          </Text>
        )
      }
      return part
    })
  }

  const formatText = (text: string) => {
    return text.split("\n\n").map((paragraph, index) => (
      <Text key={index} size="sm" c="dimmed" mb="sm">
        {formatTextWithBold(paragraph)}
      </Text>
    ))
  }

  return (
    <Card className={classes.root} radius="md" withBorder onClick={handleClick} data-selected={isSelected} data-plan-id="solo" padding="lg">
      <Stack h="100%" justify="space-between">
        <Stack gap="md">
          <Center mb="md">
            <ThemeIcon variant="light" size={64} color="blue" className={classes.icon}>
              <IconUser size={32} />
            </ThemeIcon>
          </Center>

          <Title order={1} size="h2" fw={700} c="dark" className={classes.title} ta="center" mb="md">
            {t("signUp.plans.solo.displayName")}
          </Title>

          <Stack gap="sm" ta="center">
            <Stack gap="xs" mx="lg">
              {formatText(t("signUp.plans.solo.description"))}
            </Stack>

            <Text size="sm" c="dimmed" ta="center" mx="lg">
              {t("signUp.plans.solo.additionalInfo")}
            </Text>
          </Stack>
        </Stack>

        <Button component="a" href="/sign-up/solo" fullWidth size="md" className={classes.button} variant="filled">
          {t("signUp.plans.solo.continueButton")}
        </Button>
      </Stack>
    </Card>
  )
}
